<template>
  <div class="container" :class="coupon.count > 1 ? 'multiCouponContainer' : ''">
    <div class="couponItem" :class="couponItemClasses">
      <!--  有活动描述  -->
      <div class="vipTag" v-if="shouldShowActivityMeta">
        <!--   活动名称   -->
        <div class="activityName">{{ coupon.activityName }}</div>
        <img src="../../assets/icon_cheng.png">
        <!--   数量   -->
        <div class="activityCount" v-if="coupon.count">{{ coupon.count }}张</div>
      </div>
      <!--  无活动描述，会员仅展示会员标签  -->
      <div class="vipTag" v-else-if="showVipBadge">
        <div class="activityName">{{ vipTagText }}</div>
      </div>
      <div class="couponItemBox">
        <!-- 顶部信息区域：标题 + 日期 + 金额 -->
        <div class="coupon-main">
          <!-- 左侧区域内容展示，标题+日期 -->
          <div class="divLeft">
            <!-- 优惠券名称 -->
            <div class="couponName">{{ coupon.couponName }}</div>
            <!-- 优惠券有效期 -->
            <div class="couponDate">
              {{ coupon.validDate }} - {{ coupon.invalidDate }}
            </div>
            <!-- 使用时间段 -->
            <div
              class="couponDuration"
              v-if="coupon.durationLimit"
            >
              使用时间段：{{ coupon.durationLimit }}
            </div>
          </div>
          <!-- 右侧区域内容展示，金额/折扣，满减 -->
          <div class="divRight">
            <!-- 金额/折扣 -->
            <div class="moneyDiv">
              <!-- 折扣 -->
              <div v-if="coupon.type == 30">
                <span class="money">{{ formatDiscount(coupon.type, coupon.discount) }}</span>
                <span class="moneyDes">折</span>
              </div>
              <!-- 金额 -->
              <div v-else>
                <span class="moneyDes">￥</span>
                <span class="money">{{ formatDiscount(coupon.type, coupon.discount) }}</span>
              </div>
            </div>
            <!-- 满减 -->
            <div
              class="fullDiv"
              v-show="coupon.type == 10 && coupon.full"
            >
              {{ fullTip(coupon.full) }}
            </div>
          </div>
        </div>

        <!-- 中部虚线分割 -->
        <div class="coupon-separator">
          <img class="dashImg" src="../../assets/icon_dash.png">
        </div>

        <!-- 底部使用规则 + 按钮 -->
        <div class="coupon-footer">
          <div class="footer-top">
            <!-- 底部使用规则title -->
            <div class="openRule" @click="handleToggleDescription">
              <span class="spanRule">使用规则</span>
              <img class="arrowIcon" v-if="isExpanded" src="../../assets/icon_up_arrow.png"/>
              <img class="arrowIcon" v-else src="../../assets/icon_down_arrow.png"/>
            </div>
            <!-- 底部按钮 -->
            <div
              class="button"
              :class="isVipBtn(coupon.vip)"
              v-if="showActionButton"
              @click="handleActionClick"
            >{{ actionButtonText }}</div>
          </div>
          <!-- 底部的规则 -->
          <div v-if="isExpanded" class="bottomRule">{{ coupon.description }}</div>
        </div>
      </div>
    </div>
    <div v-if="coupon.count > 1" class="bottomLine1"></div>
    <div v-if="coupon.count > 1" class="bottomLine2"></div>
  </div>
</template>

<script>
export default {
  name: "CouponItem",
  props: {
    coupon: {
      type: Object,
      required: true,
    },
    status: {
      type: Number,
      default: 1,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    showActionButton: {
      type: Boolean,
      default: false,
    },
    actionButtonText: {
      type: String,
      default: "去使用",
    },
    vipTagText: {
      type: String,
      default: "出行+ 会员券",
    },
  },
  computed: {
    // 置灰
    isDisabledStatus() {
      return this.status === 2 || this.status === 4;
    },
    // 是否展示活动描述
    shouldShowActivityMeta() {
      return this.coupon.activityName && this.coupon.count && this.status === 1;
    },
    // 是否展示会员标签
    showVipBadge() {
      return this.coupon.vip;
    },
    couponItemClasses() {
      return {
        opacity: this.isDisabledStatus,
        multiCouponItem: this.coupon.count > 1,
      };
    },
  },
  methods: {
    // 优惠券展开的点击事件
    handleToggleDescription() {
      this.isExpanded = !this.isExpanded;
    },
    // 底部按钮点击事件
    handleActionClick() {
      this.$emit("use-coupon");
    },
    // 折扣赋值转换
    formatDiscount(type, discount) {
      switch (type) {
        case 30:
          return this.formatMoney(discount * 10);
        default:
          return discount;
      }
    },
    // 格式化
    formatMoney(money) {
      var value = Math.round(parseFloat(money) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".0";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 1) {
          value = value.toString() + "0";
        }
        return value;
      }
      return value;
    },
    // 满减
    fullTip(full) {
      if (full === undefined || full === null) {
        return "";
      }
      return "满" + full / 100 + "元可用";
    },
    // vip标签
    isVipBtn(isVip) {
      if (isVip) {
        return "vipBtn";
      }
      return "Btn";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./CouponItem.scss";
</style>

